import isURL from 'validator/lib/isURL'
import { Switch } from 'antd'
import { faInfoCircle, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SynchronousCourseTypes } from 'enum'
import { useTranslationRankmi } from 'helpers/translations.helper'
import TextInput from 'components/ui/forms/field/text-input/TextInput'
import { useField, useForm } from '../../../context'
import { ShowDates } from '../../../constants'
import { SynchronousInput } from './SynchronousInput'
import { prefix } from './common'
import { Wrapper, Option, Alert, Content, Label } from './styled'

interface SynchronousCheckBoxProps {
  courseId: string
  disabled?: boolean
}

export const SynchronousCheckBox = ({
  disabled,
  courseId,
}: SynchronousCheckBoxProps) => {
  const { values, setValues, invalidFields: validationErrors } = useForm()

  const courseTypeSynchronous = useField('courseTypeSynchronous')
  const courseExternal = useField('courseExternal')
  const { courseSynchronous } = values

  const t = useTranslationRankmi({
    prefix: `${prefix}`,
  })

  return (
    <Wrapper>
      <Option>
        <Switch
          checked={courseSynchronous}
          onChange={(checked) =>
            setValues({
              ...values,
              courseSynchronous: checked,
              showDates: ShowDates.active,
            })
          }
          checkedChildren={t('courseType.synchronousV2.yes')}
          unCheckedChildren={t('courseType.synchronousV2.no')}
          disabled={disabled}
        />
        <div>{t('courseType.synchronousV2.title')}</div>
        <div>{t('courseType.synchronousV2.subtitle')}</div>
      </Option>
      <Alert>
        <FontAwesomeIcon icon={faInfoCircle} />
        {courseId
          ? t('courseType.synchronousV2.alertInEdit')
          : t('courseType.synchronousV2.alertInCreate')}
      </Alert>
      {courseSynchronous && (
        <Content>
          <SynchronousInput />
          {courseTypeSynchronous.value === SynchronousCourseTypes.external && (
            <>
              <Label>{t('courseType.synchronousV2.external.courseUrl')}</Label>
              <TextInput
                name="url"
                type="string"
                error={
                  validationErrors.synchronousUrl && (
                    <>
                      <FontAwesomeIcon icon={faCircleXmark} className="mr-1" />
                      <span>{t('validations.linkSynchronous')}</span>
                    </>
                  )
                }
                value={courseExternal.value}
                onChange={({ target: { value } }) => {
                  courseExternal.change(value)
                }}
              />
            </>
          )}
          {courseTypeSynchronous.value ===
            SynchronousCourseTypes.faceToFace && (
            <>
              <Label>
                {t('courseType.synchronousV2.external.courseLocation')}
              </Label>
              <TextInput
                name="url"
                type="string"
                value={courseExternal.value}
                onChange={({ target: { value } }) => {
                  courseExternal.change(value)
                }}
                error={
                  validationErrors.synchronousLocation && (
                    <>
                      <FontAwesomeIcon icon={faCircleXmark} className="mr-1" />
                      <span>{t('validations.locationSynchronous')}</span>
                    </>
                  )
                }
              />
            </>
          )}
        </Content>
      )}
    </Wrapper>
  )
}
